"use client";

import { useState, type ReactNode } from "react";
import { ChevronDown } from "lucide-react";

export interface FaqAccordionClientItem {
    id: number;
    question: string;
    // Sunucuda render edilmis cevap (HTML parser tarayiciya gonderilmez).
    answer: ReactNode;
}

export default function FaqAccordionClient({
    items,
    defaultOpen,
}: {
    items: FaqAccordionClientItem[];
    defaultOpen?: number;
}) {
    const [openId, setOpenId] = useState<number | null>(
        typeof defaultOpen === "number" ? defaultOpen : items[0]?.id ?? null
    );

    if (!items.length) {
        return null;
    }

    return (
        <div className="divide-y divide-[#e3ecf6] overflow-hidden rounded-2xl border border-[#dbe9f5] bg-white shadow-[0_22px_60px_-44px_rgba(5,30,60,0.25)]">
            {items.map((item) => {
                const isOpen = openId === item.id;
                return (
                    <div key={item.id}>
                        <button
                            type="button"
                            onClick={() => setOpenId(isOpen ? null : item.id)}
                            aria-expanded={isOpen}
                            aria-controls={`faq-answer-${item.id}`}
                            className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-[15px] font-semibold text-[#0f4c81] transition-colors hover:bg-[#f7fbff] md:px-6 md:py-5 md:text-[16px]"
                        >
                            <span className="flex-1">{item.question}</span>
                            <ChevronDown
                                className={`h-5 w-5 shrink-0 text-[#5d85a8] transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                                aria-hidden="true"
                            />
                        </button>
                        <div
                            id={`faq-answer-${item.id}`}
                            role="region"
                            hidden={!isOpen}
                            className="px-5 pb-5 md:px-6 md:pb-6"
                        >
                            {item.answer}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
